<app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>

<div class="row">
  <div class="col-md-12 mx-auto">
    <h3>Lista de ciudades</h3>
  </div>
  <hr />
  <div class="row align-items-center mb-3">
    <div class="col-md-6">
      <div class="input-group">
        <input
          type="text"
          id="table-complete-search"
          name="searchText"
          class="form-control"
          placeholder="Buscar ciudad"
          [(ngModel)]="filterText"
          (keyup)="filterRecords()"
        />

        <button
          class="btn btn-outline-danger ms-1"
          type="button"
          (click)="clearSearch()"
        >
          Limpiar busqueda
        </button>

        <button
          class="btn btn-outline-primary ms-1"
          type="button"
          (click)="reloadInfo()"
          placement="top"
          ngbTooltip="Refrescar informacion"
        >
          <i class="bi bi-arrow-clockwise"></i>
        </button>
      </div>
    </div>
    <div class="col-md-6">
      <div class="d-grip gap-1 d-md-flex justify-content-md-end">
        <a [routerLink]="['/cities/create']" class="btn btn-outline-success">
          <i class="bi bi-plus-circle"></i>
          Crear ciudades
        </a>
      </div>
    </div>
  </div>
  <hr />

  <form>
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="col">ID</th>
          <th class="col">Ciudad</th>
          <th class="col">Estado</th>
          <th class="col">C&oacute;digo del estado</th>
          <th class="col">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let city of filterCities
              | paginate : { itemsPerPage: 15, currentPage: page }
          "
        >
          <td scope="row">
            {{ city.id }}
          </td>
          <td>
            {{ city.city_name }}
          </td>
          <td>
            {{ city.state_name }}
          </td>
          <td>
            {{ city.country_code }}
          </td>
          <td>
            <div class="d-flex d-flex-row">
              <div>
                <a
                  [routerLink]="['/cities/edit', city.id]"
                  placement="top"
                  ngbTooltip="Editar"
                  role="button"
                  class="btn btn-primary"
                >
                  <i class="bi bi-pencil-square"></i>
                </a>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="col-md-12 d-flex align-items-center justify-content-center">
      <pagination-controls
        (pageChange)="page = $event"
        nextLabel="Siguiente"
        previousLabel="Anterior"
        class="mt-3"
      ></pagination-controls>
    </div>
  </form>
</div>
